import AgencyIndex from './Index'
import AgencyForm from './Form'
import AgencyDetails from './Details'

export default [
  {
    path: '/agency',
    name: 'agency',
    component: AgencyIndex,
    meta: {
      auth: true,
      bodyClass: 'navbar-top',
      breadcrumb: 'Agencies'
    }
  },
  {
    path: '/agency/details/:oid',
    name: 'agency.details',
    props: true,
    component: AgencyDetails,
    meta: {
      breadcrumb: 'Agency Details'
    }
  },
  {
    path: '/agency/add',
    name: 'agency.create',
    props: true,
    component: AgencyForm,
    meta: {
      breadcrumb: 'New agency'
    }
  }
]
